import React from "react";
import { FiFileText, FiX } from "react-icons/fi";
import SelectField from "../ui/SelectField";
import { UPLOAD_CATEGORIES } from "../options";

/*
Attached files with a category select each - the customer tells us which
file is the POP and which the POR, so triage does not have to guess.
`categories` defaults to all of them.
*/
export default function UploadRows({
  uploads,
  onCategoryChange,
  onRemove,
  categories = UPLOAD_CATEGORIES,
}) {
  if (uploads.length === 0) return null;

  return (
    <div className="rma-nc-upload-rows">
      {uploads.map((upload) => (
        <div key={upload.id} className="rma-nc-upload-row">
          <FiFileText className="rma-nc-upload-row-icon" size={18} strokeWidth={1.8} />
          <span className="rma-nc-upload-row-name">{upload.name}</span>
          <div className="rma-nc-upload-row-select">
            <SelectField
              value={upload.category}
              options={categories}
              onChange={(category) => onCategoryChange(upload.id, category)}
            />
          </div>
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(upload.id)}
              aria-label={`Remove ${upload.name}`}
              className="rma-nc-upload-row-remove"
            >
              <FiX size={14} strokeWidth={2} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
